module.exports = __webpack_public_path__ + "static/media/mana.7a5e1d84.png";